import DifferenceCard from './DifferenceCard';

export default DifferenceCard;
